import {
  ErrorOutlineOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  ChipGroup,
  EllipsisText,
  Flex,
  Text,
  type GridColDef,
} from '@shared/components';

export interface ExamDistributionAvailableQSetListItem {
  examId: number;
  code: string;
  name: string;
  duration: React.ReactElement;
  availableQSets: string[];
  availableQSetCount: number;
  examCenterCourses: string[];
}

function renderAvailableQSetCountCell({ row }: { row: ExamDistributionAvailableQSetListItem }) {
  const count = row.availableQSetCount;
  const isQSetEmpty = count === 0;

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(2),
        alignItems: 'center',
      })}
    >
      {isQSetEmpty ? (
        <ErrorOutlineOutlinedIcon sx={{ color: (theme) => theme.palette.error.main }} />
      ) : (
        <CheckCircleOutlineRoundedIcon sx={{ color: (theme) => theme.palette.success.main }} />
      )}
      <Text>{count} ชุด</Text>
    </Flex>
  );
}

export const columns: GridColDef<ExamDistributionAvailableQSetListItem>[] = [
  {
    field: 'examId',
    headerName: 'ExamID',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
  },
  {
    field: 'code',
    headerName: 'Code',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => <EllipsisText>{row.code}</EllipsisText>,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    sortable: false,
    renderCell: ({ row }) => <EllipsisText>{row.name}</EllipsisText>,
  },
  {
    field: 'availableQSetCount',
    headerName: 'จำนวนชุดข้อสอบ',
    width: 150,
    sortable: false,
    renderCell: renderAvailableQSetCountCell,
  },
  {
    field: 'duration',
    headerName: 'ระยะเวลาสอบ',
    width: 168,
    sortable: false,
    renderCell: ({ row }) => row.duration,
  },
  {
    field: 'availableQSets',
    headerName: 'ชุดข้อสอบที่พร้อมใช้งาน',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => (
      <EllipsisText>
        {row.availableQSets.length > 0
          ? row.availableQSets.map((qSetCode) => qSetCode.split(`${row.code}-`)[1]).join(', ')
          : '-'}
      </EllipsisText>
    ),
  },
  {
    field: 'examCenterCourses',
    headerName: 'ศูนย์ทดสอบ',
    width: 180,
    sortable: false,
    renderCell: ({ row }) =>
      row.examCenterCourses.length === 0 ? (
        <EllipsisText variant='body1Semibold'>-</EllipsisText>
      ) : (
        <ChipGroup labels={row.examCenterCourses} limit={2} direction='row' />
      ),
  },
];
